import { Component, Input } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup
} from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Job, job_params } from "src/app/views/common/models/job_model";
import { OpJobService } from "src/app/views/common/services/op-job.service";
import { isEqual } from 'lodash';
import { CommonService } from "src/app/views/common/services/common.service";

@Component({
  selector: "app-orderdeadlinedialog",
  templateUrl: "./orderdeadlinedialog.component.html",
  styleUrls: ["./orderdeadlinedialog.component.css"],
})
export class OrderdeadlinedialogComponent {
  [x: string]: any;
  @Input() name: string;
  @Input() exportData: any;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  deadlineForm: FormGroup;
  route: any;
  confirmationDialogService: any;
  mandatoryPostage: boolean = false;
  initialValues: any;

  constructor(
    public activeModal: NgbActiveModal,
    private jobService: OpJobService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private commonServ: CommonService
  ) { }

  buildJobForm() {
    this.deadlineForm = new FormGroup({
      deadlineDate: new FormControl(this.exportData.postage_end_date ? this.exportData.postage_end_date : 'MM-dd-yyyy'),
      isPostageMandatory: new FormControl(this.exportData.isPostageMandatory == "true" ? true : false),
      estimatedDeliveryDate: new FormControl(this.exportData.estimated_delivery_date ? this.exportData.estimated_delivery_date : 'MM-dd-yyyy'),
    });
    this.initialValues = this.deadlineForm.value;
  }

  ngOnInit() {
    this.buildJobForm();
  }

  onSubmit() {
    this.activeModal.close();
    let formValues = this.deadlineForm.value;
    let rawValue = this.initialValues;
    let job_params: Job = this.prepareBody(formValues);
    if (JSON.stringify(rawValue) !== JSON.stringify(formValues)) {
      this.jobService.updateOrderDeadlineByJob(job_params).subscribe(
        (res: any) => {
          this.deadlineForm.reset();
          this.activeModal.close();
          this.toastr.success("Proofcard Details Updated Successfully", "Job", {
            positionClass: "toast-top-center",
          });
        },
        (err: any) => {
          if (err.status == 302) {
            this.toastr.error(err.error.message, "Job", {
              positionClass: "toast-top-center",
            });
          } else {
            console.error(err);
          }
          console.log("date ", job_params);
        }
      );
    }
  }

  prepareBody(formValues) {
    job_params.id = this.exportData.id;
    job_params.postage_end_date = formValues.deadlineDate;
    job_params.estimated_delivery_date = formValues.estimatedDeliveryDate;
    job_params.isPostageMandatory = formValues.isPostageMandatory.toString();
    return job_params;
  }


  dismiss() {
    this.activeModal.dismiss();
  }

  onDeadlineChange(newDeadlineDateString: string) {
    console.log('onDeadlineChange called with:', newDeadlineDateString);

    // Convert the string to a Date object
    const newDeadlineDate = new Date(newDeadlineDateString);

    if (!isNaN(newDeadlineDate.getTime())) {
      // Calculate the new estimatedDeliveryDate by adding 7 days
      const newEstimatedDeliveryDate = this.commonServ.addDays(newDeadlineDate, 7);

      // Update the estimatedDeliveryDate form control
      this.deadlineForm.get('estimatedDeliveryDate').setValue(newEstimatedDeliveryDate.toISOString().split('T')[0]);
    } else {
      console.log('Invalid date format:', newDeadlineDateString);
    }
  }

}
